goog.provide('el8.app.settings.printHeaders');

goog.require('el8.app.settings.util');
goog.require('el8.template.app.settings.printHeaders');
goog.require('el8.uiwidget.confirm');
goog.require('el8.uiwidget.Form');
goog.require('el8.util.consts');


el8.app.settings.printHeaders = (function() {

    var that = {};
    var form;
    var $container;

    that = {

        init: function(_container) {

            $container = _container;

            // create initial frame
            var $content = $(el8.template.app.settings.printHeaders.content());
            $container.html($content).show();

            bindTriggers($container);

            el8.data.printHeaders.load(function() {
                $('.print-header-list', $container).removeClass('el8Loading');
            }, true);

        }

    };

    function bindTriggers($container) {
        var $list = $('.print-header-list', $container);

        el8.data.printHeaders.bind('all', function() {
            renderHeaderList();
        });

        $container.on('click', '.add-header-trigger',  function() {
            showForm($('.new-form-stub', $list));

        }).on('click', '.edit-header-trigger',  function() {
            showForm($(this).closest('.header-item'));

        }).on('click', '.remove-header-trigger',  function() {
            var id = $(this).closest('.header-item').data('id');
            var header = el8.data.printHeaders.getById(id);
            el8.uiwidget.confirm("Are you sure you want to permanently delete this print header?",
                function() { el8.data.printHeaders.deleteItem(header); }
            );

        }).on('change', '.mark-default-radio',  function() {
            var id = $(this).closest('.header-item').data('id');
            if (!id) { return false; }
            el8.data.currUser.setPrimaryPrintHeaderId(id);
            el8.data.currUser.updatePreferences();
        });
    }

    function renderHeaderList() {
        var $list = $('.print-header-list', $container);
        $list.html(
            el8.template.app.settings.printHeaders.headerList({
                headers: el8.data.printHeaders.sortedAsSoyMaps(),
                practice: el8.data.currPractice.asSoyMap()
            })
        );
        form = null;

        var primaryHeaderId = el8.data.currUser.getPrimaryPrintHeaderId();
        if (primaryHeaderId) {
            $('.mark-default-radio[value="'+primaryHeaderId+'"]', $list).prop('checked', true);
        }
    }

    function showForm($elem) {
        if (form) {
            el8.uiwidget.alert('Please finish editing the existing header or discard it first.');
            return;
        }

        var elemId = $elem.data('id');
        var header;
        if (elemId) {
            header = el8.data.printHeaders.getById(elemId);
        } else {
            header = el8.data.printHeaders.create({}, true); // noNotify: re-render when saved
        }

        $elem.replaceWith(el8.template.app.settings.printHeaders.headerForm());
        var $form = $('form.header-form', $container);

        form = new el8.uiwidget.Form({
            container: $form,
            buttonElt: $('.header-form-buttons', $form),
            fields: [
                {
                    name: 'name',
                    selector: ':input[name="name"]',
                    maxLength: 200,
                    infoText: 'What do you want to call this header?',
                    validate: {
                        required: true
                    }
                },
                {
                    name: 'header',
                    selector: ':input[name="header"]',
                    height: 4 * el8.util.consts.DEFAULT_FIELD_HEIGHT,
                    noGrow: true,
                    maxLength: 500,
                    infoText: 'Type your header as you want it to appear on your printouts'
                },
                {
                    name: 'contentType',
                    selector: ':input[name="contentType"]',
                    infoText: 'Choose between a text-only header and an image header'
                },
                {
                    name: 'imagePlacement',
                    selector: 'select[name="imagePlacement"]',
                    infoText: 'Indicate how the image should be positioned on the page'
                }
            ],
            validationOpts: el8.util.validate.standardOpts
        });
        form.addSaveButton(function() {
            if (!form.isValid()) { return; }
            if (form.getVal('header').split(/\r\n|\r|\n/).length > 4) {
                el8.uiwidget.alert('Please limit your print headers to four lines or fewer.');
                return;
            }
            if (form.getVal('contentType') === "1" && !header.getHeaderImage()) {
                el8.uiwidget.alert('Please upload an image before saving.');
                return;
            }

            header.populate(form.getMapped());
            el8.data.printHeaders.saveItem(header);
        }, true);
        form.addButton('preview', 'Preview', function() { openPreviewPage(form, header); });
        form.addCancelButton(renderHeaderList);
        form.render();
        form.populate(header.asSoyMap());

        var $imageContainer = $form.find('.header-image-container');
        var $imageDropWidget = $form.find('.image-drop-widget');
        var $imageDropArea = $form.find('.image-drop-area');
        var $imageUploadSpinner = $form.find('div[name="headerImageUploadSpinner"]');
        displayHeaderImage(header);

        var fileUploader = new el8.uiwidget.FileUploader({
            container: $imageDropArea,
            isImageUpload: true,
            droppableArea: $imageDropArea,
            droppableZoneClass: '',
            url: function() {
                return header.getId() ? el8.service.urls.get('practiceHeaders', [header.getId()])
                                      : el8.service.urls.get('practiceHeaders');
            },
            success: function(raw_headers) {
                // Endpoint may return one or two headers; the first one is for the uploaded image
                // and the second (if present) is a default header that was just created
                if (raw_headers.length === 2) {
                    el8.data.printHeaders.create(raw_headers[1], true);
                }
                header.populate(raw_headers[0]);
                el8.data.printHeaders.addOrUpdate(header, true);
                $elem.data('id', header.getId());
                displayHeaderImage(header, function() {
                    $imageUploadSpinner.hide();
                    $imageDropArea.show();
                    form.enable();
                    showImageTipsIfApplicable(header);
                });
            },
            error: function() {
                $imageUploadSpinner.hide();
                $imageDropArea.show();
                form.enable();
            },
            onUploadFn: function() {
                form.disable();
                $imageDropArea.hide();
                $imageUploadSpinner.show();
                hideImageTips();
            }
        });

        $form.on('click', '.text-content-trigger',  showTextView);
        $form.on('click', '.image-content-trigger',  showImageView);
        $form.on('change', 'select[name="imagePlacement"]',  function() {
            displayHeaderImage(header);
            showImageTipsIfApplicable(header);
        });

        if ($form.find('.image-content-trigger').is(':checked')) {
            showImageView();
        }

        $form.on('mouseenter', '.image-drop-area',  function() {
            $imageDropWidget.show();
        }).on('mouseleave', '.image-drop-area',  function() {
            if ($imageContainer.children().length > 0) {
                $imageDropWidget.hide();
            }
        });

        $form.on('click', '.image-tips-alert .ebs-close',  function() {
            hideImageTips();
        });

        function showTextView() {
            $form.find('.content-type-specific').hide();
            $form.find('.text-content-pane').show();
        }

        function showImageView() {
            $form.find('.content-type-specific').hide();
            $form.find('.image-content-pane').show();
            $form.find('.image-placement-select').show();
            fileUploader.show();
        }

        function displayHeaderImage(header, onloadFn) {
            var imageUrl = header.getHeaderImage();
            var headerSoyMap = header.asSoyMap();
            headerSoyMap.contentType = 1; // This function is specifically for displaying the image
            headerSoyMap.imagePlacement = parseInt(form.getVal('imagePlacement'), 10);
            if (imageUrl) {
                $imageContainer.html(el8.template.data.practices.customHeader({header: headerSoyMap}));
                if (onloadFn) {
                    $imageContainer.find('img.header-image').load(onloadFn);
                }
                $imageDropWidget.hide();
            }
            else {
                $imageContainer.html('');
                $imageDropWidget.show();
            }
        }

        function showImageTipsIfApplicable(header) {
            var alertText = null;

            if (form.getVal('imagePlacement') === "3" /* Fit to width */) {
                if (header.getHeaderImageWidth() < 1232 /* Half of max width */) {
                    alertText = "The uploaded image is small and may appear blurry when printed";
                }
            }
            else if (header.getHeaderImageHeight() < 240 /* Max height is 400 */) {
                alertText = "The uploaded image might be too small; try uploading a larger one";
            }

            var $alertContainer = $form.find(".image-tips-alert");
            var $alertLink = $alertContainer.find("a[name='image-tips-alert-text']");
            if (alertText !== null) {
                $alertLink.html(alertText);
                $alertContainer.show();
            }
            else {
                hideImageTips();
            }
        }

        function hideImageTips() {
            $form.find(".image-tips-alert").hide();
        }
    }

    function openPreviewPage(form, header) {
        // Take all user-entered (possibly unsaved) data from form, but header image (always saved,
        // if not null) from the header itself
        var previewHeader = el8.data.printHeaders.create(form.getMapped(), true);
        previewHeader.setHeaderImage(header.getHeaderImage());
        previewHeader.setHeaderImageWidth(header.getHeaderImageWidth());
        previewHeader.setHeaderImageHeight(header.getHeaderImageHeight());
        // TODO: get the url from somewhere proper
        var $previewForm = $('<form target="_blank" method="post" action="/print-header-preview/"></form>');
        var $input = $('<input type="text" name="header"></input>');
        $input.attr('value', JSON.stringify(previewHeader.asSoyMap()));
        $previewForm.append($input);
        $previewForm.submit();
        // TODO: need to clean up the created form element?
    }

    return that;

})();
